import React, {FunctionComponent, useState} from 'react';
import {motion} from 'framer-motion';

import { ReactComponent as ArrowUp } from '../../../../assets/icons/icon_chevron_up_pink.svg'
import { ReactComponent as ArrowDown } from '../../../../assets/icons/icon_chevron_down.svg'

interface Props {
    title: string;
    children: any;

    initialOpen?: boolean;
    className?: string;
}

const FilterSection: FunctionComponent<Props> = ({ children, title, initialOpen, className }) => {

    const [open, setOpen] = useState<boolean>(initialOpen ?? false);

    const toggleSection = () => setOpen(!open);

    const variants = {
        open: {
            height: 'auto'
        },
        closed: {
            height: 0
        }
    };

    const Icon = open ? ArrowUp : ArrowDown;

    return (
        <div className={`filter-section ${className ? className : ''}`}>
            <div className={'filter-section__title-container'} onClick={toggleSection}>
                <div className={'filter-section__title'}>
                    <span className={'filter-section__text filter-section__text--title'}>{ title }</span>
                </div>

                <Icon className={'filter-section__icon'} />
            </div>

            <motion.div variants={variants} initial={'closed'} animate={open ? 'open' : 'closed'} className={'filter-section__content'}>
                <div className={'filter-section__spacer'}>
                    { children }
                </div>
            </motion.div>
        </div>
    );
};

export default FilterSection;
